<template>
  <div class="">
    <ul class="newTaxUL">
      <li>
        <div class="newTaxTitle required">{{$t('base.photoOrPDF')}}</div>
        <div>
          <div class="photoBox" v-if="imgbase.src">
            <div class="photoMark" v-if="imgbase.type==0"></div>
            <div class="photoClose" @click="photoClose" v-if="imgbase.type!=0"></div>
            <el-image class="photoImg" fit='contain' :src="imgbase.src" v-if="imgbase.type==1" :preview-src-list="[imgbase.src]" />
            <a :href="imgbase.src" target="_blank" v-if="imgbase.type==2">
              <el-image :src="fileUrl" class="photoImg" fit='contain' />
            </a>
          </div>
          <el-upload v-if="!imgbase.src" :before-upload="getDialog" :http-request="uploadImg" action="" accept="application/pdf,image/jpeg,image/png" :limit="picListLimit" :show-file-list="false">
            <div class="newImgs">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </div>
      </li>
      <li>
        <div class="newTaxTitle required">Tax payer(the same as tax certificate)</div>
        <el-input class="newTaxInput" v-model="taxDetail.RealName" placeholder='Enter Tax payer(the same as tax certificate)' />
      </li>
      <li>
        <div class="newTaxTitle">Company Name</div>
        <el-input class="newTaxInput" v-model="taxDetail.CompanyName" placeholder='Enter Company name' />
      </li>
      <li>
        <div class="newTaxTitle">Note</div>
        <el-input class="newTaxInput" v-model="taxDetail.Note" type="textarea" placeholder='Enter note' maxlength="30" show-word-limit />
      </li>
      <li>
        <div class="newTaxTitle">{{$t('base.ordertype')}}</div>
        <div class="newTaxTab">
          <div :class="{'on':newTaxTab==2}" @click="newTaxTab=2">{{$t('base.crossBorder')}}</div>
          <div :class="{'on':newTaxTab==3}" @click="newTaxTab=3">{{$t('base.domestic')}}</div>
        </div>
      </li>
      <li>
        <div class="newTaxTitle reselect "><div class="required">{{$t('base.taxrefundorders')}}</div><span @click="goto(newTaxTab,'taxorder')">{{$t('base.reselect')}}</span></div>
        <!-- 没订单 -->
        <div class="taxRefundOrders" v-if="!orderList">
          <div class="Select" @click="goto(newTaxTab,'taxorder')">
            <div></div>
            {{$t('base.select')}}
          </div>
          <tax-order :userInfo='userInfo' :orderType='newTaxTab' dialogClass="taxBox" :domVisible='dislogType.taxorder' @getOrderList="getOrderList" @closeDialog="closeDialog" v-if='dislogType.taxorder' />
        </div>
        <!-- 有订单 -->
        <div v-if="orderList">
          <div class="orderList orderListTop">
            <div>{{$t('base.orderNumber')}}</div>
            <div>{{$t('base.taxrefundamount')}}</div>
            <div>{{$t('base.orderTotal')}}</div>
            <div class="createTime">{{$t('base.createTime')}}</div>
            <div class="operate">{{$t('base.operate')}}</div>
          </div>
          <el-scrollbar>
            <ul class="taxRefundOrdersBox">
              <li class="orderList" v-for="(item,index) in orderList">
                <div>{{item.Code}}</div>
                <div>{{item.RealLowestPriceUnit}} {{item.TaxPriceUsd.toFixed(2)}}</div>
                <div>{{item.RealLowestPriceUnit}} {{item.RealTotalPrice.toFixed(2)}}</div>
                <div class="createTime">{{setTime(item.CreateDate)}}</div>
                <div class="operate"><span class="view" @click="goto(item,'taxorderlist')">{{$t('base.viewDetails')}}</span></div>
              </li>
            </ul>
          </el-scrollbar>
          <tax-order-list title="Order Details" :userInfo='userInfo' :list="taxOrderDetail" dialogClass="taxBox" :domVisible='dislogType.taxorderlist' @closeDialog="closeDialog" v-if='dislogType.taxorderlist' />
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { getTime } from "@/api/public";
import TaxOrderList from "@/components/dialog/taxorderlist"; // 
import TaxOrder from "@/components/dialog/taxorder"; // 
import Guid from 'guid';
import COS from 'cos-js-sdk-v5'
let cos = "";
let cosData = "";
export default {
  name: 'tax',
  components: { TaxOrderList, TaxOrder },
  data() {
    return {
      newTaxTab: 3,
      fileUrl: '../../../static/images/icon/icon_file.svg',
      imgbase: { src: '', type: 0 },
      picListLimit: 1,
      cosConfig: this.$enumInfo.cosConfig,
      dislogType: this.$enumInfo.dislogType,
      orderList: null,
      taxOrderDetail: {},
      taxDetail: {
        MemberId: this.userInfo.MappingUserId,
        BusinessType: 3,
        Explain: '',
        RealName: '',
        CompanyName: '',
        Note: '',
        OrderIds: [],
        Proves: []
      }
    }
  },
  props: {
    userInfo: {}
  },
  watch: {
    'orderList': {
      handler(obj) {
        let that = this
        var OrderIds = []
        if (obj) {
          obj.map(res => {
            OrderIds.push(res.ID)
          })
        }
        that.taxDetail.OrderIds = OrderIds
        that.checkTaxDetail()
      }
    },
    'imgbase': {
      deep: true,
      handler(obj) {
        let that = this
        if (obj) {
          var Proves = []
          if (obj.type != 0) {
            var data = { Type: obj.type, Url: obj.src }
            Proves.push(data)
          }
          that.taxDetail.Proves = Proves
          that.checkTaxDetail()
        }
      }
    },
    'taxDetail.RealName': {
      handler(obj) {
        let that = this
        that.checkTaxDetail()
      }
    },
    'newTaxTab': {
      handler(obj) {
        let that = this
        if (obj) {
          if ((that.taxDetail.BusinessType != obj) && that.taxDetail.BusinessType) {
            that.orderList = null
          }
          that.taxDetail.BusinessType = obj
          that.checkTaxDetail()
        }
      }
    }
  },
  created() {
    let that = this
    that.NowCos()
  },
  mounted() { },
  methods: {
    /**
     * 初始化腾讯云 COS 对象存储实例
     * 获取临时密钥进行 COS 操作授权
     * 优先从 cookie 获取缓存的授权信息，若无缓存则重新请求
     * @method NowCos
     * @returns {void}
     * @description
     * - 从 cookie 获取 cosData，包含临时密钥信息
     * - 若 cookie 中无数据，则调用接口获取新的临时密钥
     * - 将获取的临时密钥缓存到 cookie，有效期1.5小时
     * - 初始化 COS 实例用于后续文件操作
     */
    NowCos() {
      let that = this
      cos = new COS({
        getAuthorization: function(options, callback) {
          if (that.$cookie.get("cosData")) {
            cosData = JSON.parse(that.$cookie.get("cosData"));
            //console.log("$cookie.get.costoken", cosData);
            var credentials = cosData.Credentials;
            var cb = {
              TmpSecretId: credentials.TmpSecretId,
              TmpSecretKey: credentials.TmpSecretKey,
              SecurityToken: credentials.Token,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: parseInt(cosData.StartTime), // 时间戳，单位秒，开始时间，即获取时刻的时间戳
              ExpiredTime: parseInt(cosData.ExpiredTime) // 时间戳，单位秒，超时时刻的时间戳
            }
            //console.log("callback",cb);
            callback(cb);
          } else {
            that.$get(that.$interface.costoken, '').then(res => {
              console.log("costoken", res);
              try {
                cosData = res;
                that.$cookie.set("cosData", JSON.stringify(res), { expires: new Date(new Date().getTime() + 1.5 * 60 * 60 * 1000) });
                //console.log("getAuthorization2 - data", cosData);
                var credentials = cosData.Credentials;
              } catch (e) {}
              if (!cosData || !credentials) {
                return console.error('credentials invalid:\n' + cosData)
              };
              var cb = {
                TmpSecretId: credentials.TmpSecretId,
                TmpSecretKey: credentials.TmpSecretKey,
                SecurityToken: credentials.Token,
                // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                StartTime: parseInt(cosData.StartTime), // 时间戳，单位秒，开始时间，即获取时刻的时间戳
                ExpiredTime: parseInt(cosData.ExpiredTime) // 时间戳，单位秒，超时时刻的时间戳
              }
              //console.log("callback",cb);
              callback(cb);
            })
          }
        }
      })
      console.log('COS:', cos)
    },
    //上传图片之前的方法，判断图片的格式
    /**
     * 处理文件上传对话框的方法
     * @param {File} file - 上传的文件对象
     * @description 验证上传文件类型(JPG/PNG/PDF),并处理图片预览
     * - 如果是图片文件(JPG/PNG),使用FileReader读取并显示预览
     * - 如果是PDF文件,使用已有的fileUrl显示
     * - 不合法的文件类型会显示错误提示
     * @returns {boolean} 文件类型验证结果
     */
    getDialog(file) {
      let that = this
      console.log(file, 'file')
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf');
      if (!isJPG) {
        this.$message.error(that.$enumInfo.error['NOimg']);

        //that.uploadFile = file;
        return false
      } else {
        let fileUrl;
        that.uploadFile = file;
        if (file.type === 'image/jpeg' || file.type === 'image/png') {
          // console.log(that.uploadFile, 'uploadImg')
          let f = new FileReader()
          //读取es6格式的图片
          f.readAsDataURL(file)
          //文件读取成功之后把图片赋值给imgbase
          f.onload = function(e) {
            fileUrl = this.result
            that.imgbase.src = fileUrl
          }
        } else {
          that.imgbase.src = that.fileUrl
        }
      }
    },
    // 上传图片
    /**
     * 上传图片或PDF文件到腾讯云COS或服务器API
     * 支持两种上传方式:
     * 1. COS直传: 生成唯一文件名并上传到配置的腾讯云COS存储桶
     * 2. API上传: 通过FormData将文件上传到服务器接口
     * 
     * 上传成功后更新imgbase对象:
     * - src: 文件访问URL
     * - type: 1表示图片,2表示PDF
     * 
     * @private
     * @returns {void}
     */
    uploadImg() {
      let that = this
      var uploadType = process.env.NODE_ENV == "development" ? "api" : "cos"; //cos api
      if (uploadType == "cos") {
        var myGuid = Guid.raw();
        var fileType = that.uploadFile.type == 'image/png' ? ".png" : '.jpg';
        if (that.uploadFile.type == 'application/pdf') {
          fileType = '.pdf'
        }
        var imgKey = that.cosConfig.Prefix + myGuid.replace(/-/g, "") + fileType;
        cos.putObject({
            Bucket: that.cosConfig.Bucket,
            /* 必须 */
            Region: that.cosConfig.Region,
            /* 存储桶所在地域，必须字段 */
            Key: imgKey,
            /* 必须 */
            Prefix: that.cosConfig.Prefix,
            StorageClass: 'STANDARD',
            Body: that.uploadFile, // 上传文件对象
            Headers: {
              'x-cos-request-id': cosData.RequestId
            },
            onProgress: function(progressData) {
              console.log("onProgress:", JSON.stringify(progressData));
            },
          },
          function(err, data) {
            console.log("err", err);
            console.log("data", data);
            console.log("that.cosConfig", that.cosConfig, imgKey, myGuid.replace(/-/g, ""));
            if (err) {
              that.$message.error(this.$t('alert.phoneUrlFail'));
            } else {
              that.imgbase.src = that.cosConfig.ImagesUrl + imgKey
              that.imgbase.type = 1
              if (fileType == '.pdf') {
                that.imgbase.type = 2
              }
            }

          })
      } else {
        var fd = new FormData();
        fd.append('file', that.uploadFile);
        //console.log(that.uploadFile, 'file')
        this.$post(this.$interface.UploadImage, fd).then(res => {
          //console.log(res);
          if (res.result) {
            that.imgbase.src = res.data
            that.imgbase.type = 1
            if (that.uploadFile.type === 'application/pdf') {
              that.imgbase.type = 2
            }
          } else {
            this.$message.error("请求图片地址失败");
          }
        })
      }
    },
    photoClose() {
      this.imgbase = { src: '', type: 0 }
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
    },
    getOrderList(obj, bol) {
      console.log(obj, 'getOrderList')
      this.orderList = obj
      //this.dislogType[val] = bol;
    },
    /**
     * 切换页面或更新数据状态
     * @param {Object} obj - 税单详情对象
     * @param {string} val - 目标页面标识，可选值: 'taxorder'/'taxorderlist'
     * @description 当 newTaxTab 为 true 时:
     * - 若 val 为 'taxorder'，清空订单列表
     * - 若 val 为 'taxorderlist'，更新税单详情
     * - 调用 closeDialog 方法切换页面
     */
    goto(obj, val) {
      if (this.newTaxTab) {
        if (val == 'taxorder') {
          this.orderList = null
        }
        if (val == 'taxorderlist') {

          this.taxOrderDetail = obj
        }
        this.closeDialog(val, true)
      }
    },
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    /**
     * 校验发票申请表单详情数据的完整性
     * @description 检查表单必填项是否已填写，包括会员ID、业务类型、真实姓名、订单ID和证明材料
     * @fires isSubmit 触发表单验证状态事件，true表示验证不通过，false表示验证通过
     * @returns {boolean} 返回false表示验证不通过
     */
    checkTaxDetail() {
      let that = this
      let data = that.taxDetail
      if (!data.MemberId) {
        console.log('data.MemberId')
        that.$emit('isSubmit', true)
        return false
      }
      if (!data.BusinessType) {
        console.log('data.newTaxTab')
        that.$emit('isSubmit', true)
        return false
      }
      if (!data.RealName) {
        console.log('data.newTaxTab')
        that.$emit('isSubmit', true)
        return false
      }
      if (data.OrderIds.length <= 0) {

        console.log('data.OrderIds')
        that.$emit('isSubmit', true)
        return false
      }
      if (Object.keys(data.Proves).length <= 0) {
        console.log('data.Proves')
        that.$emit('isSubmit', true)
        return false
      }
      that.$emit('isSubmit', false)
    }
  }
}

</script>
<style scoped>
.taxRefundOrders {
  background-color: #f7f7f7;
  border-radius: 8px;
  width: 100%;
  min-height: 50px;
}

.taxRefundOrders .Select {
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  color: #a0a0a0;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.taxRefundOrders .Select>div {
  width: 40px;
  height: 40px;
  background: url(../../../static/images/order.png) no-repeat;
  background-size: contain;
  margin-bottom: 4px;
}

.newTaxUL li {
  margin: 11px 0 25px;
}

.newTaxTitle {
  color: #a0a0a0;
  margin-bottom: 8px;
  position: relative;
}

.newTaxTitle.reselect {
  display: flex;
  justify-content: space-between;
}

.newTaxTitle.reselect>span {
  color: #5f6dae;
  cursor: pointer;
}

.newTaxTab {
  display: flex;
}

.newTaxTab>div {
  padding: 7px 20px;
  border: 1px solid #c8c8c8c8;
  border-radius: 4px;
  line-height: 1.5;
  cursor: pointer;
}

.newTaxTab>div.on {
  border-color: #5f6dae;
  background-color: #5f6dae;
  color: #fff;
}

.newTaxTab>div+div {
  margin-left: 8px;
}

.taxRefundOrdersBox {
  max-height: 410px;
}

.orderList {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}

.orderListTop {
  background-color: #f7f7f7;
}

.orderList>div {
  width: 20%;
  padding: 16px 12px;
  color: #333;
  box-sizing: border-box;
}

.orderList>div.createTime {
  width: 25%;
}

.orderList>div.operate {
  width: 15%;
}

.view {
  cursor: pointer;
}

.view:hover {
  color: #5F6DAE;
  text-decoration: underline;
}

.newImgs {
  width: 104px;
  height: 104px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f7f7f7;
  border-radius: 8px;
}

.photoBox {
  width: 104px;
  height: 104px;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 8px;
  background-color: #f7f7f7;
}

.photoBox .photoMark {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  position: absolute;
  z-index: 9;
  border-radius: 8px;
}

.photoBox .photoClose {
  position: absolute;
  background: url(../../../static/images/icon/icon_close_red.png) center no-repeat;
  background-size: contain;
  width: 16px;
  height: 16px;
  z-index: 9;
  cursor: pointer;
  top: -6px;
  right: -8px;
}

.photoBox .photoImg {
  width: 104px;
  height: 104px;
}

.required::after {
  content: "*";
  color: #f00;
}

</style>



// WEBPACK FOOTER //
// src/pages/user/newtax.vue